// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    justify-content: center;
    align-items: center;
    height: 100vh;
    margin: 0;
}
.button-container {
    display: flex;
    gap: 10px;
}
.mandatory{
  color: red;
  /* font-weight: bold; */
}
.center-content {
  margin: auto !important;
  text-align: center;
}
.file-container {
    border: 2px solid #0B2D71;
    width: 100%;
    margin: 20px auto;
    background-color: #fff;
}
.select-text {
  color: white;
  padding: 5px;
  background-color: #0B2D71;
  text-align: left;
  /* border-radius: 5px 5px 0 0; */
  font-family: "GothamBold",Arial,sans-serif;
}
.form-group {
  margin-bottom: 1rem;
}
table th {
  background-color: #0b2d71 !important;
  color: white;
  font-weight: bold;
}
th, td {
  border: 1px solid white;
  text-align: center;
  padding: 8px;
}
.title {
    background-color: #6699cc;
    color: #ffffff;
    padding: 10px;
    text-align: center;
    font-size: 100%;
  }
  .title h3 {
    color: white !important;
    text-align: left;
    margin-top: auto;
    margin-bottom: auto;
    }
  .details-container {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
  }
  
  .left-column, .right-column {
    width: 48%;
  }
  .details-table {
    width: 100%;
    table-layout: auto; /* Adjust column widths based on content */
    border-collapse: collapse;
  }

  .details-table th, .details-table td {
    padding: 8px;
    text-align: left;
    border: 1px solid #ddd;
  }
.details-table th {
  background-color: #f2f2f2;
}

.details-table td {
  white-space: nowrap; /* Prevent text wrapping */
}

.details-table .details-container {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }

.details-table .left-column, .details-table .right-column {
  width: 48%;
}

.details-table .left-column p, .details-table .right-column p {
  margin: 0 0 10px;
}
  
  .left-column p, .right-column p {
    margin: 0 0 10px;
  }
 /* Adjust column widths */
.details-table th:nth-child(1), .details-table td:nth-child(1) {
    width: 5%; /* Adjust as needed */
  }
  
  .details-table th:nth-child(2), .details-table td:nth-child(2) {
    width: 20%; /* Adjust as needed */
  }
  
  .details-table th:nth-child(3), .details-table td:nth-child(3) {
    width: 15%; /* Adjust as needed */
  }
  
  .details-table th:nth-child(4), .details-table td:nth-child(4) {
    width: 15%; /* Adjust as needed */
  }
  
  .details-table th:nth-child(5), .details-table td:nth-child(5) {
    width: 15%; /* Adjust as needed */
  }
  
  .details-table th:nth-child(6), .details-table td:nth-child(6) {
    width: 10%; /* Adjust as needed */
  }
  
.table-responsive th, .table-responsive td {
    flex: 1 1 auto;
    min-width: 100px; /* Adjust as needed */
    max-width: 200px; /* Adjust as needed */
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .bordered-container {
    border: 1px solid #d3d3d3; 
    padding: 20px;
    max-width: 100%;
    margin: 3% 0%;
    border-radius: 1px;
  }`, "",{"version":3,"sources":["webpack://./src/app/modules/temporaryredelegation/editorcancelredelegation/editorcancelredelegation.component.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,SAAS;AACb;AACA;IACI,aAAa;IACb,SAAS;AACb;AACA;EACE,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;EAChC,0CAA0C;AAC5C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB;EACF;IACE,gBAAgB;IAChB,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB,EAAE,0CAA0C;IAC9D,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;EACxB;AACF;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB,EAAE,0BAA0B;AACjD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;EAClB;;AAEF;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;EAEE;IACE,gBAAgB;EAClB;CACD,yBAAyB;AAC1B;IACI,SAAS,EAAE,qBAAqB;EAClC;;EAEA;IACE,UAAU,EAAE,qBAAqB;EACnC;;EAEA;IACE,UAAU,EAAE,qBAAqB;EACnC;;EAEA;IACE,UAAU,EAAE,qBAAqB;EACnC;;EAEA;IACE,UAAU,EAAE,qBAAqB;EACnC;;EAEA;IACE,UAAU,EAAE,qBAAqB;EACnC;;AAEF;IACI,cAAc;IACd,gBAAgB,EAAE,qBAAqB;IACvC,gBAAgB,EAAE,qBAAqB;IACvC,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,aAAa;IACb,kBAAkB;EACpB","sourcesContent":[":host {\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    margin: 0;\n}\n.button-container {\n    display: flex;\n    gap: 10px;\n}\n.mandatory{\n  color: red;\n  /* font-weight: bold; */\n}\n.center-content {\n  margin: auto !important;\n  text-align: center;\n}\n.file-container {\n    border: 2px solid #0B2D71;\n    width: 100%;\n    margin: 20px auto;\n    background-color: #fff;\n}\n.select-text {\n  color: white;\n  padding: 5px;\n  background-color: #0B2D71;\n  text-align: left;\n  /* border-radius: 5px 5px 0 0; */\n  font-family: \"GothamBold\",Arial,sans-serif;\n}\n.form-group {\n  margin-bottom: 1rem;\n}\ntable th {\n  background-color: #0b2d71 !important;\n  color: white;\n  font-weight: bold;\n}\nth, td {\n  border: 1px solid white;\n  text-align: center;\n  padding: 8px;\n}\n.title {\n    background-color: #6699cc;\n    color: #ffffff;\n    padding: 10px;\n    text-align: center;\n    font-size: 100%;\n  }\n  .title h3 {\n    color: white !important;\n    text-align: left;\n    margin-top: auto;\n    margin-bottom: auto;\n    }\n  .details-container {\n    margin-top: 20px;\n    display: flex;\n    justify-content: space-between;\n  }\n  \n  .left-column, .right-column {\n    width: 48%;\n  }\n  .details-table {\n    width: 100%;\n    table-layout: auto; /* Adjust column widths based on content */\n    border-collapse: collapse;\n  }\n\n  .details-table th, .details-table td {\n    padding: 8px;\n    text-align: left;\n    border: 1px solid #ddd;\n  }\n.details-table th {\n  background-color: #f2f2f2;\n}\n\n.details-table td {\n  white-space: nowrap; /* Prevent text wrapping */\n}\n\n.details-table .details-container {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 20px;\n  }\n\n.details-table .left-column, .details-table .right-column {\n  width: 48%;\n}\n\n.details-table .left-column p, .details-table .right-column p {\n  margin: 0 0 10px;\n}\n  \n  .left-column p, .right-column p {\n    margin: 0 0 10px;\n  }\n /* Adjust column widths */\n.details-table th:nth-child(1), .details-table td:nth-child(1) {\n    width: 5%; /* Adjust as needed */\n  }\n  \n  .details-table th:nth-child(2), .details-table td:nth-child(2) {\n    width: 20%; /* Adjust as needed */\n  }\n  \n  .details-table th:nth-child(3), .details-table td:nth-child(3) {\n    width: 15%; /* Adjust as needed */\n  }\n  \n  .details-table th:nth-child(4), .details-table td:nth-child(4) {\n    width: 15%; /* Adjust as needed */\n  }\n  \n  .details-table th:nth-child(5), .details-table td:nth-child(5) {\n    width: 15%; /* Adjust as needed */\n  }\n  \n  .details-table th:nth-child(6), .details-table td:nth-child(6) {\n    width: 10%; /* Adjust as needed */\n  }\n  \n.table-responsive th, .table-responsive td {\n    flex: 1 1 auto;\n    min-width: 100px; /* Adjust as needed */\n    max-width: 200px; /* Adjust as needed */\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  .bordered-container {\n    border: 1px solid #d3d3d3; \n    padding: 20px;\n    max-width: 100%;\n    margin: 3% 0%;\n    border-radius: 1px;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
